<template>
      <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
    
      <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-5 pb-5">
          <!-- Login Tab Content -->
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h1 :style="{ marginTop: '20px' }">
                  Patient Encounter & Detailed Analysis
                </h1>
                <h3 :style="{ marginTop: '20px' }">
                  In-depth Insights into Every Patient Interaction
                </h3>
                <h5 :style="{ marginTop: '20px' }">
                  {{ main_data }} Comprehensive Analysis of Patient
                  Encounters
                </h5>
                <p :style="{ marginTop: '20px' }">
                  Understanding every facet of a patient's interaction with
                  healthcare providers is crucial for delivering superior care.
                  {{ main_data }} system for Patient Encounter & Detailed
                  Analysis offers healthcare professionals a granular view of
                  each patient interaction, from complaints to diagnoses,
                  ensuring darkrmed decisions and personalized care.
                </p>
              </div>
              <div class="col-md-12 col-lg-5">
                <img style="height: 350px;"
                  src="@/assets/img/encounter.jpg"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
          <!-- /Login Tab Content -->
        </div>
      </div>
    </div>
    <!-- Key Feature Section -->

    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h3 class="first_section_heading pb-5 pt-5" align="center">
          Key Features
        </h3>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Detailed Encounter Logs"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Capture Every Interaction</h4>
            <b-card-text
              >Document every patient interaction, from initial complaints and
              symptoms to the provided treatments and follow-ups. Maintain a
              chronological record for future reference and continuity of
              care.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Complaint Analysis"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Understand Patient Concerns</h4>
            <b-card-text
              >Delve into the specifics of each patient complaint, categorizing
              and analyzing them to ensure appropriate and effective
              responses.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Diagnosis Overview"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>A Clear Picture of Patient Health</h4>
            <b-card-text
              >TReview detailed diagnostic darkrmation, from clinical findings
              to lab results. Ensure accurate and timely interventions based on
              comprehensive data.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;margin-bottom: 40px;">
          <b-card
            border-variant="dark"
            header="Treatment Analysis"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Track and Evaluate Treatment Efficacy</h4>
            <b-card-text
              >Monitor the outcomes of prescribed treatments, evaluating their
              effectiveness and making necessary adjustments for optimal patient
              outcomes.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Integration with Other Features"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Seamless Connectivity for Comprehensive Care</h4>
            <b-card-text
              >Ensure the patient encounter data seamlessly integrates with
              other features like the Prescription Slip Automation and Treatment
              Plan Templates for a cohesive patient care
              experience.</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
      </div>
    </div>

    <!-- Benefit Section-->

    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h3
          style="text-align: center; padding-bottom: 20px; margin-top: 40px;margin-bottom: 40px;"
        >
          Enhancing Care Through Insightful Analysis
        </h3>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Precision"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Make darkrmed decisions based on detailed and accurate patient
              interaction data.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Efficiency"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Quickly access and review patient encounters, streamlining the
              decision-making process.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Collaboration"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Derive actionable insights from encounter data to improve patient
              outcomes.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;">
          <b-card
            border-variant="dark"
            header="Personalization"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Tailor treatments and interventions based on individual patient
              needs and histories.</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
        
        <!--Call Action Section -->
        <div class="mt-5"
          style="display: flex; justify-content: center; align-items: center;"
        >
          <div style="width: 500px; text-align: center;">
            <b-card bg-variant="info" text-variant="white" title="" style="border: 1px solid black;">
              <b-card-text style="text-align: center;">
                Elevate the standard of patient care with {{ main_data }}
                Patient Encounter & Detailed Analysis feature. Register now to
                gain unparalleled insights into every patient interaction!
              </b-card-text>
              <b-button href="#" variant="dark" style="text-align: center;">
                Register Now
              </b-button>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>


    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/EncounterDetailed.vue